var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-status-indicator"},[(_vm.pending)?_c('Icon',{staticClass:"pending-icon",attrs:{"type":"mdi","path":_vm.icons.loading,"size":_vm.size}}):_c('Icon',{class:_vm.dirty ? 'dirty-icon' : 'check-icon',attrs:{"type":"mdi","path":_vm.dirty ? _vm.icons.exclamation : _vm.icons.check,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }